import instance from '@/services/repository';

const resource = '/tasktemplates';

export default {
    getAll() {
        return instance.get<ITaskTemplateDto[]>(`${resource}`);
    },
    getSingle(id: string) {
        return instance.get<ITaskTemplateDto>(`${resource}/${id}`);
    },
    create(payload: ITaskTemplateCreateCommand) {
        return instance.post<string>(`${resource}`, payload);
    },
    update(payload: ITaskTemplateUpdateCommand) {
        return instance.put(`${resource}/${payload.id}`, payload);
    },
    delete(id: string) {
        return instance.delete(`${resource}/${id}`);
    },
};
